export class ForgetPasswordDto{
    newPassword:string;
    confirmPassword:string;
    resetToken:string;
    email:string;
}